import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { useSession } from '../misc/session_context'
import RentalPlan from '../helpers/rental_plan'
import SalePlan from '../helpers/sale_plan'
import CurrencyUSD, { dollarStringToNumber } from '../misc/currency_formats'
import { Button } from 'lensrentals-components'

import styles from '../../assets/stylesheets/pages/cart/checkout.module.scss'

const Checkout = props => {
  const [sessionData] = useSession()
  const oppositeCart = {
    sale: {
      name: 'Rent Cart',
      size: sessionData.cart?.size
    },
    rental: {
      name: 'Buy Cart',
      size: JSON.parse(localStorage.getItem('saleCart'))?.cart?.reduce((count, item) => count + item.quantity, 0) || 0
    }
  }

  const {
    cartPlan: {
      type,
      cart,
      total,
      itemSubtotal,
      insurancePrice,
      warrantyPrice,
      enrollInHd,
      hdEnrolled,
      hdPrice,
      shipping,
      cannotCheckout
    }
  } = props

  const {
    currentUser
  } = sessionData

  const typeLabel = {
    rental: 'to rent',
    sale: 'for purchase'
  }

  const cartIsEmpty = !cart.length

  const ShippingPrice = () => {
    const {
      price,
      discount,
      shippingMethod,
      proposedPickupRate
    } = shipping

    if ((enrollInHd || hdEnrolled) && discount !== '$0.00' && discount !== 0) {
      const total = dollarStringToNumber(price) + dollarStringToNumber(discount)

      return (
        <span className={cx(styles['shipping-price'], styles['shipping-price--discounted'])}>
          <span>{price}</span> <s><CurrencyUSD amount={total} /></s>
        </span>
      )
    } else if (shippingMethod === 'Pickup from Bay Area' && proposedPickupRate) {
      return (
        <span className={styles['shipping-price']}>
          <span style={{ marginRight: '5px', color: '#4eb857' }}>
            <CurrencyUSD amount={0} />
          </span>
          <span style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', borderBottom: 'medium solid red', width: '100%', top: '6px', transform: 'rotate(20deg)', opacity: '0.6' }} />
            <span style={{ position: 'absolute', borderBottom: 'medium solid red', width: '100%', top: '6px', transform: 'rotate(-20deg)', opacity: '0.6' }} />
            <CurrencyUSD amount={proposedPickupRate} />
          </span>
        </span>
      )
    } else {
      return <span className={styles['shipping-price']}><CurrencyUSD amount={price} /></span>
    }
  }

  return (
    <>
      <div
        id='totals'
        className={cx(
          styles.checkout__totals,
          'totals'
        )}
      >
        {!!cart.length &&
          <>
            <span
              className={cx(
                styles['checkout__totals-line'],
                'subtotal'
              )}
            >
              <label>Subtotal</label>
              <span className={styles['checkout__totals-amount']}>
                <CurrencyUSD amount={itemSubtotal} />
              </span>
            </span>
            <span
              className={cx(
                styles['checkout__totals-line'],
                'insurance'
              )}
            >
              <label>Coverage</label>
              <span className={styles['checkout__totals-amount']}>
                <CurrencyUSD amount={insurancePrice || warrantyPrice} />
              </span>
            </span>
            <span
              className={cx(
                styles['checkout__totals-line'],
                'ship_price'
              )}
            >
              <label>Shipping Estimate</label>
              <span className={styles['checkout__totals-amount']}>
                {(!!shipping?.price || shipping.price === 0) ? <ShippingPrice shipping={shipping} /> : 'Call for shipping'}
              </span>
            </span>
          </>}

        {enrollInHd &&
          <span
            className={cx(
              styles['checkout__totals-line'],
              'lrhd_price'
            )}
          >
            <label>Lensrentals HD</label>
            <span className={styles['checkout__totals-amount']}><CurrencyUSD amount={hdPrice} /></span>
          </span>}

        <span
          className={cx(
            styles['checkout__totals-line'],
            styles['checkout__totals-line--total'],
            'total'
          )}
        >
          <label>Total (excluding tax)</label>
          <span className={styles['checkout__totals-amount']}>
            {total || total === 0 ? <CurrencyUSD amount={total} /> : 'Call for price'}
          </span>
        </span>
      </div>

      {cannotCheckout &&
        <p className={styles.checkout__warning}>
          There is an item in your cart that is no longer available {typeLabel[type]}. Please remove the item to checkout.
        </p>}

      <div className={styles.checkout__actions}>
        {(cartIsEmpty && oppositeCart[type].size)
          ? <p className={cx('alert', styles.checkout__warning)}>You have {oppositeCart[type].size} item in your {oppositeCart[type].name}.</p>
          : null}

        {/*
          we don't want to POST this form, just navigate and /checkout will read the cart its
          own way
        */}
        <Button
          id='submit'
          color='confirm'
          disabled={cartIsEmpty || cannotCheckout}
          href={`/checkout?checkout_type=${type === 'rental' ? 'rent' : 'buy'}`}
        >
          Proceed to Checkout
        </Button>

        <Button id='continue_shopping' href='/'>
          Continue Shopping
        </Button>

        {type === 'rental' && !cartIsEmpty && !!currentUser?.email &&
          <Button id='save-cart' href='/cart_quotes/new'>
            Save This Cart
          </Button>}
      </div>
    </>
  )
}

Checkout.propTypes = {
  cartPlan: PropTypes.oneOfType([
    PropTypes.instanceOf(RentalPlan),
    PropTypes.instanceOf(SalePlan)
  ]).isRequired
}

export default Checkout
